"use strict";

angular.module("licensure.services").factory("TGTriggers", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/TGTriggers/", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getByID: function(id, trigger_object_id, config_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/TGTriggers/" + id, {
                        params: {
                            trigger_object_id: trigger_object_id,
                            config_id: config_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (trigger, trigger_object_id, trigger_config_id) {
                var d = $q.defer();


                if (isUndefined(trigger.id)) {
                    d.resolve(null);
                } else {
                    var url = apiLocation + "/api/TGTriggers/" + trigger.id;

                    $http({
                        method: "PUT",
                        url: url,
                        data: {
                            trigger: trigger,
                            trigger_action_values: trigger.trigger_action_values,
                            trigger_object_id: trigger_object_id,
                            trigger_configuration_id: trigger_config_id
                        }
                    })
                        .then(function (response) {
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            // handle error
                        });
                }

                return d.promise;
            },

            fire: function(code, object_id) {
                var d = $q.defer();

                $http
                    .post(apiLocation + "/api/TGTriggers/fire", {
                        code: code,
                        object_id: object_id
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
